import { gql } from 'apollo-boost';

export const fragments = {

	OBJECTIVES: {
		QUERY_RETURN: `id name displayName`
	},

	OBJECTIVE: {
		QUERY_RETURN:    `id name displayName description ordinal`,
		MUTATION_RETURN: `id name displayName description ordinal`,
		EDIT_FIELDS:     `
			id
			name
			displayName
			description
			ordinal
			refIdCode
		`
	},
};

export const queries = {

	GET_OBJECTIVES: ( returnQueryString = fragments.OBJECTIVES.QUERY_RETURN ) => gql`
	  query GetObjectives( $order: [ObjectiveSortInput!], $where: ObjectiveFilterInput ){
		objectives( order: $order, where: $where) {
			${ returnQueryString }
		}
	}`,

	GET_OBJECTIVE: ( returnQueryString = fragments.OBJECTIVE.QUERY_RETURN ) => gql`
	  query GetObjective( $id: Uuid! ){
        objective( id: $id ) {
            ${ returnQueryString }
        }
	  }`,
};

export const mutations = {

	CREATE_OBJECTIVE: ( returnQueryString = fragments.OBJECTIVE.MUTATION_RETURN ) => gql`
	  mutation CreateObjective( $input: ObjectiveCreateCommandInput! ){
	    createObjective( input: $input ) {
	        ${ returnQueryString }
	    }
	  }`,

	UPDATE_OBJECTIVE: ( returnQueryString = fragments.OBJECTIVE.MUTATION_RETURN ) => gql`
	  mutation UpdateObjective( $input: ObjectiveUpdateCommandInput! ){
	    updateObjective( input: $input ) {
	        ${ returnQueryString }
	    }
	  }`,

	DELETE_OBJECTIVE: () => gql`
	  mutation DeleteObjective( $input: ObjectiveDeleteCommandInput! ){
	    deleteObjective( input: $input )
	  }`,

	UPDATE_OBJECTIVE_ORDER: ( returnQueryString = fragments.OBJECTIVE.QUERY_RETURN ) => gql`
	  mutation updateObjectiveOrder( $input: ObjectiveUpdateOrdinalsCommandInput! ){
	    updateObjectiveOrdinals( input: $input ) {
	        ${ returnQueryString }
	    }
	  }`,
};

export const functions = {}

export const ObjectiveGroupQueries = {
	fragments,
	queries,
	mutations,
	functions,
};
